









































































































































































































import _ from 'lodash';
import {Vue, Component} from 'vue-property-decorator';
import { State, Action, namespace } from 'vuex-class';
import { ActionError as campaignStoreErr } from '@/store/campaign/types';

import { DefaultOption, TableOptionType } from '@/const/options/DefaultTableOption';

import { CurrentCampaignType } from '@/store/campaign/types';
import { Setting as terms } from '@/const/terms/mainTerms';
import { SetCampaign as feedbackTerms} from '@/const/terms/feedback/campaign';


import { STATUS, STATUS_EXPLAINING } from '@/const/status';
import {
    ICampaignHistoryResponse, ICampaignHistory,
} from './historyTypes';

import { TableColumn } from 'element-ui/types/table-column';
import { ElTable } from 'element-ui/types/table';
import { CampaignInfoResponse, CategoryOptionResponseType } from './editingTypes';
import { AdvertiserDataType } from '@/pages/partner/legacy/types';
import { AxiosError, AxiosResponse } from 'axios';
import { ORIGIN_FORMAT } from '@/utils';

const campaignModule = namespace('Campaign');

@Component<CampaignHistory>({
    name: 'CampaignHistory',
})
export default class CampaignHistory extends Vue{
    private terms = terms;

    private DateFormatDetailOrigin = ORIGIN_FORMAT.DateFormatDetailOrigin;
    private NumberFormatOrigin = ORIGIN_FORMAT.NumberFormatOrigin;
    private STATUS = STATUS;
    private STATUS_EXPLAINING = STATUS_EXPLAINING;

    private isUtilsCollapsed: boolean = false;
    private loading: boolean = false;

    private customIDExist: boolean = false;
    private categoryList: CategoryOptionResponseType = {divisions: [], sections: []};
    private advertiserList: AdvertiserDataType = [];
    private tableData: ICampaignHistory[] = [];
    private tableOptions: TableOptionType = DefaultOption;
    
    @campaignModule.State(state => state.currentCampaign) private currentCampaign!: CurrentCampaignType;
    @campaignModule.Action('SET_CURRENT_CAMPAIGN') private setCurrentCampaign!: any;
    
    private getHistoryResponseHandler() {
        this.loading = true;
        this.getHistoryResponse().then((res: any) => res.data)
            .then((data: ICampaignHistoryResponse[]) => {
                this.tableData = data.map((item: ICampaignHistoryResponse, index: number) => {
                    const modifiedList: (keyof ICampaignHistory)[] = [];
                    if (item.customID) {
                        this.customIDExist = true;
                    } 
                    if (index !== 0) {
                        (Object.keys(item) as (keyof ICampaignHistoryResponse)[]).forEach((key: keyof ICampaignHistoryResponse) => {
                            if (key === 'status') {
                                if ((data[index - 1][key] & STATUS.ACTIVE) !== (item[key] & STATUS.ACTIVE)) {
                                    modifiedList.push(key as keyof ICampaignHistory);
                                }
                            } else {
                                if ( !(_.isEqual(data[index - 1][key], item[key])) ) {
                                    modifiedList.push(key as keyof ICampaignHistory);
                                }
                            }
                        })
                    }
                    return {
                        ...item,
                        modifiedList: modifiedList,
                    } as ICampaignHistory;
                })
            })
                .catch((err: AxiosError) => {
                    if(err.response && (err.response as AxiosResponse).status !== 200) {
                        this.$notify.error(feedbackTerms.getResponse.error.fail);
                    } else {
                        this.$notify.error(err.message);
                    }
                    throw err;
                })
                .finally(() => {
                    this.loading = false;
                    this.$nextTick(() => {
                        const table = this.$refs.table as ElTable;
                        table.doLayout();
                    })
                })
    }

    private getHistoryResponse() {
        return this.$http.adserverAPI.post('GetCampaignHistory', {
            campaign_id: this.currentCampaign.id,
        })
    }

    private getCategoryResponse() {
        return  this.$http.adserverAPI.post('GetCategoryList').then((res: any) => res.data)
            .then((data: CategoryOptionResponseType) => {
                this.categoryList = data;
            })
    }

    private getAdvertiserResponse() {        
        return this.$http.adserverAPI.post('GetAdvCompanyList').then((res: any) => res.data)
            .then((data: AdvertiserDataType) => {
                this.advertiserList = data;
            })
    }
    private async created() {
        if (!(this.$route.params.campaignID && this.$route.params.campaignID.toString().length >= 16)) {
            this.$router.push({name: 'campaign'});
            this.$notify.error(feedbackTerms.history.error.invalidCampaign);
            return;
        }
        if (this.$route.params.campaignID !== this.currentCampaign.id) {
            const campaignID = this.$route.params.campaignID;
            this.loading = true;
            await this.$http.adserverAPI.post('GetCampaignInfo', {campaign_id: campaignID}).then((res: any) => res.data)
                .then(async (data: CampaignInfoResponse) => {
                    if (data && (data as any).result === null) {
                        throw new Error(feedbackTerms.getResponse.error.notFound);
                    }
                    try {                        
                        await this.setCurrentCampaign({
                            id: data.id,
                            name: data.name,
                            app: data.app,
                        });
                    } catch (err) {
                        switch (err.type) {
                            case campaignStoreErr.SET_CURRENT_CAMPAIGN:
                                throw new Error(feedbackTerms.getResponse.error.setCurrentCampaign);
                                break;
                        }
                        throw new Error(feedbackTerms.getResponse.error.fail);
                    }
                })
                .catch((err: AxiosError) => {
                    if(err.response && (err.response as AxiosResponse).status !== 200) {
                        this.$notify.error(feedbackTerms.getResponse.error.fail);
                    } else {
                        this.$notify.error(err.message);
                        this.$router.push({name: 'campaign'});
                    }
                    throw err;
                })
                .finally(() => {
                    this.loading = false;
                })
        }
        this.getCategoryResponse();
        this.getAdvertiserResponse();
        this.getHistoryResponseHandler();
    }
}
